module.exports = __webpack_public_path__ + "img/icon-sb-shop-the-collection-48x48.5a7d4ff.svg";